import { createContext, useEffect, useRef, useState } from "react";
import "./App.css";
import { Route, BrowserRouter, Routes } from "react-router-dom";
import PublicData from "pages/PublicData";
import Cookies from "js-cookie";
import { GoogleOAuthProvider } from "@react-oauth/google";
import { FacebookProvider } from "react-facebook";
import * as api from "apis/FusionAPI";


export const AuthContext = createContext({
  auth: null,
  setAuth: () => {},
});

export const MobileContext = createContext({
  mobile: false,
});

export const AppContext = createContext({
  mobile: false,
});

function App() {
  const [auth, setAuth] = useState(null);
  const [mobile, setMobile] = useState(false);
  const [fullscreenMap, setFullscreenMap] = useState(false);

  const mutex = useRef();

  useEffect(() => {
    (async () => {
      if (mutex.current) return;
      mutex.current = true;

      Cookies.remove("accessToken");
      const refreshToken = Cookies.get("refreshToken");

      let refreshResult;

      try {
        refreshResult = await api.refresh();
      } catch (error) {
        console.log("Error in auto refresh:", error);
        return;
      }

      console.log("refresh Result:", refreshResult);

      if (
        refreshResult?.status === 200 &&
        refreshResult.data.accessToken &&
        refreshResult.data.refreshToken &&
        refreshResult.email
      ) {
        Cookies.set("accessToken", refreshResult.data.accessToken);
        Cookies.set("refreshToken", refreshResult.data.refreshToken);
        Cookies.set("email", refreshResult.email);

        setAuth({
          ...auth,
          email: refreshResult.email,
          accessToken: refreshResult.data.accessToken,
          refreshToken: refreshResult.data.refreshToken,
        });
      } else {
        Cookies.remove("refreshToken");
      }

      mutex.current = false;
    })();

    //detect if mobile based on user agent
    if (
      /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
        navigator.userAgent
      )
    ) {
      console.log("Mobile detected");
      setMobile(true);
    }
  }, []);

  return (
    <GoogleOAuthProvider clientId={process.env.REACT_APP_GOOGLE_CLIENT_ID}>
      <FacebookProvider appId={process.env.REACT_APP_FACEBOOK_CLIENT_ID}>
        <ContextProvider
          auth={{
            auth,
            setAuth,
          }}
          mobile={{
            mobile,
            setMobile,
          }}
          app={{
            fullscreenMap,
            setFullscreenMap,
          }}
        >
          <div
            style={{
              display: "flex",
              flexDirection: "row",
              backgroundSize: "cover",
              backgroundRepeat: "repeat",
              width: "100vw",
              height: "100vh",
              flex: 1,
              flexGrow: 1,
            }}
          >
            <div
              style={{
                width: "100%",
                overflowY: "auto",
                overflowX: "hidden",
              }}
            >
              <BrowserRouter>
                <Routes>
                  {/* Root path route */}
                  <Route
                    path="/"
                    element={
                      <PageContentWrapper fullscreenMap={fullscreenMap}>
                        <PublicData />
                      </PageContentWrapper>
                    }
                  />
                  {/* Dynamic parameter route - this will capture any value after the slash */}
                  <Route
                    path="/:paramValue"
                    element={
                      <PageContentWrapper fullscreenMap={fullscreenMap}>
                        <PublicData />
                      </PageContentWrapper>
                    }
                  />
                </Routes>
              </BrowserRouter>
            </div>
          </div>
        </ContextProvider>
      </FacebookProvider>
    </GoogleOAuthProvider>
  );
}

export default App;

const PageContentWrapper = ({ children, fullscreenMap }) => {
  return (
    <div
      className={
        fullscreenMap ? "" : "page-content customScrollbar-X customScrollbar-Y"
      }
      style={
        fullscreenMap
          ? { height: "100%" }
          : { height: "100%", background: "#0b1826" }
      }
    >
      {children}
    </div>
  );
};

const ContextProvider = ({ children, auth, mobile, app }) => {
  return (
    <AuthContext.Provider value={auth}>
      <MobileContext.Provider value={mobile}>
        <AppContext.Provider value={app}>{children}</AppContext.Provider>
      </MobileContext.Provider>
    </AuthContext.Provider>
  );
};
